import { assert } from '../../lib/assert-sidecar'
import { rando } from '../../lib/rando-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageFakeInfo } from './voyageFakeInfo-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import type { IVoyageSystemData } from './voyageSystemsData'
import { voyageSystemsData } from './voyageSystemsData-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import type { IVoyageTilemapPart } from './voyageTilemapPart'

export interface IVoyageSystemState {
  ammo: number
  nickname: string
  frozenCrewName: string
  data: IVoyageSystemData
}

export const createSystemState = (tile: IVoyageTilemapPart) => {
  let data = voyageSystemsData.find(tile)
  tile.system = {
    ammo: 0,
    nickname: '',
    frozenCrewName: '',
    data,
  }
}

export const init = (tile: IVoyageTilemapPart) => {
  // console.log('init system')
  createSystemState(tile)
  assert.notNil(tile.system)
  tile.system.nickname = voyageFakeInfo.genFakeProjectName()
  tile.system.ammo = tile.system.data.startsWithAmmo

  if (tile.system.data.onCreate) {
    tile.system.data.onCreate(tile.system)
  }
}

export function findSystem(name: string) {
  return voyageTilemap.getSystem(name)
}

export function useSystem(obj: IVoyageCrew, tCur: IVoyageTilemapPart) {
  if (tCur.system) {
    tCur.system.data.crewUpdate(obj)
  }

  // if (tCur.tile3.type === EVoyageTile.System) {
  //   if (tCur.text3 === 'sensor-internal') {
  //     voyageSystems_internalSensor.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('sensor-external')) {
  //     voyageSystems_externalSensor.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('med')) {
  //     voyageSystems_med.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('cryo')) {
  //     voyageSystems_cryo.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('reactor')) {
  //     voyageSystems_reactor.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('life-support')) {
  //     voyageSystems_lifeSupport.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('crematorium')) {
  //     voyageSystems_crematorium.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('laser')) {
  //     voyageSystems_laser.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('torpedo')) {
  //     voyageSystems_torpedo.crewUpdate(obj)
  //   }
  //   if (tCur.text3.startsWith('loader')) {
  //     voyageSystems_torpedoLoader.crewUpdate(obj)
  //   }
  // }
  // if (tCur.tile3.type === EVoyageTile.MedPad) {
  //   voyageSystems_medPad.crewUpdate(obj)
  // }
}

const phrases = [
  'No power',
  'Not responding',
  'Agh!',
  'Stupid machine',
  'Someone fix the reactor',
]
export function testNoPower(obj: IVoyageCrew) {
  let status = voyageGameStatus.get()
  if (status.power > 5) {
    return false
  }
  if (rando.chance(0.25)) {
    voyageCrew.say(obj, rando.sample(phrases))
  }
  return true
}
